import Hospitals from './Hospitals';

export default Hospitals;
